import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { LuGalleryVerticalEnd as LuImages, LuHouse, LuInfo, LuMessageSquare, LuPhoneCall } from 'react-icons/lu';

const links = [
  { hash: '#home', label: 'Home', icon: LuHouse },
  { hash: '#gallery', label: 'Gallery', icon: LuImages },
  { hash: '#about', label: 'About', icon: LuInfo },
  { hash: '#testimonials', label: 'Testimonials', icon: LuMessageSquare }
];

const sectionTo = (hash) => ({ pathname: '/', hash });

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="fixed w-full bg-white/90 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          <div className="flex-shrink-0 flex items-center">
            <span className="text-2xl font-bold text-pink-600 font-serif tracking-tight">
              Nithuja Cakes
            </span>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-6">
              {links.map(({ hash, label, icon: Icon }) => (
                <Link
                  key={hash}
                  to={sectionTo(hash)}
                  className="text-gray-700 hover:text-pink-600 px-3 py-2 text-sm font-medium transition-colors duration-200"
                >
                  <span className="flex items-center gap-2">
                    <Icon className="h-4 w-4" aria-hidden="true" />
                    {label}
                  </span>
                </Link>
              ))}
              <Link
                to={sectionTo('#order')}
                className="bg-pink-600 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-pink-700 transition-colors duration-200 shadow-md hover:shadow-lg inline-flex items-center gap-2"
              >
                <LuPhoneCall className="h-4 w-4" aria-hidden="true" />
                Order Now
              </Link>
            </div>
          </div>
          <div className="md:hidden">
            <button
              className="text-gray-700 p-2 rounded-lg border border-gray-200"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
        <div className={`${isMenuOpen ? 'max-h-screen' : 'max-h-0'} md:hidden overflow-hidden transition-all duration-300`}>
          <div className="flex flex-col space-y-4 py-6 border-t border-gray-200">
            {links.map(({ hash, label, icon: Icon }) => (
              <Link
                key={hash}
                to={sectionTo(hash)}
                onClick={closeMenu}
                className="text-gray-700 hover:text-pink-600 text-base font-medium"
              >
                <span className="inline-flex items-center gap-3">
                  <Icon className="h-5 w-5 text-pink-500" aria-hidden="true" />
                  {label}
                </span>
              </Link>
            ))}
            <Link
              to={sectionTo('#order')}
              onClick={closeMenu}
              className="inline-flex items-center justify-center px-5 py-3 rounded-full bg-pink-600 text-white font-semibold shadow-md hover:bg-pink-700 gap-2"
            >
              <LuPhoneCall className="h-5 w-5" aria-hidden="true" />
              Order Now
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
